export { default } from './PostCard';
export { Component } from './PostCard';
